import React, { useEffect, useRef, useState } from 'react'
import * as S from './styles'
import Table from 'presentation/shared/components/Table'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import { LoadSurgicalOrderNoticeCard } from 'domain/usecases/surgical-pendency/load-surgical-order-notice-card'
import { LoadSurgicalOrderGuides } from 'domain/usecases/surgical-order-guides/load-surgical-order-guides'
import {
  LoadSurgicalOrderGuideAuthorization,
  SurgicalOrderGuideAuthorization
} from 'domain/usecases/surgical-order-guides/load-surgical-order-guides-authorization'
import moment from 'moment'
import { CheckIntegrationOvermind } from 'domain/usecases/eligibility/check-integration-overmind'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { ReactComponent as PlusIcon } from 'presentation/assets/icons/plus.svg'
import { ReactComponent as PencilIcon } from 'presentation/assets/icons/pencil-icon.svg'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/trash-icon.svg'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import { accommodations, getTranslatedAuthorizationStatus } from './utils'
import SelectField from 'presentation/shared/components/SelectField'
import { ReactComponent as DownloadIcon } from 'presentation/assets/icons/DonwloadIcon.svg'

type Props = {
  surgicalOrderNoticeCard?: LoadSurgicalOrderNoticeCard.Model
  loadSurgicalOrderNoticeCard: () => void
  setIsLoading: any
  isLoading: any
}

type SurgicalOrderGuideAuthorizationProps = {
  surgicalOrderGuideAuthorization: LoadSurgicalOrderGuideAuthorization.Model
}

export const AuthorizationTab = ({
  surgicalOrderNoticeCard,
  setIsLoading
}: Props) => {
  const [error, setError] = useState('')
  const [accommodation, setAccommodation] = useState(undefined) as any
  const [selectedQuantity, setSelectedQuantity] = useState(1) as any
  const [isEditingQuantity, setIsEditingQuantity] = useState(false)
  const [isAddingRow, setIsAddingRow] = useState(false)
  const [selectedProcedureRow, setSelectedProcedureRow] = useState('')
  const [formatedConsultGuideItems, setFormatedConsultGuideItems] =
    useState() as any

  const [surgicalOrderGuides, setSurgicalOrderGuides] =
    useState<LoadSurgicalOrderGuides.Model>()

  const [surgicalOrderGuideAuthorization, setSurgicalOrderGuideAuthorization] =
    useState<LoadSurgicalOrderGuideAuthorization.Model>()

  const [
    activeSurgicalOrderGuideAuthorization,
    setActiveSurgicalOrderGuideAuthorization
  ] = useState<SurgicalOrderGuideAuthorization>()

  const [integrationOvermindInfo, setIntegrationOvermindInfo] =
    useState<CheckIntegrationOvermind.Model>()

  const surgicalOrderGuideService = useServices().surgicalOrderGuide
  const eligibilityService = useServices().eligibility

  function onRowClick(evt: any) {
    setSelectedProcedureRow(evt[1])
  }

  function addRow() {
    setIsAddingRow(true)
    setFormatedConsultGuideItems([
      ...formatedConsultGuideItems,
      {
        description: '',
        health_insurance_procedure_id: '',
        operation_type: null,
        procedure_id: '',
        quantity: 1,
        surgical_order_guide_item_id: 0
      }
    ])
  }

  function cancelAddRow() {
    if (isEditingQuantity) {
      setIsEditingQuantity(false)
      return
    }
    const slicedConsultGuideItems = formatedConsultGuideItems.slice(0, -1)
    setFormatedConsultGuideItems(slicedConsultGuideItems)
    setIsAddingRow(false)
    setIsEditingQuantity(false)
  }

  function removeItem(value: number) {
    if (
      activeSurgicalOrderGuideAuthorization &&
      activeSurgicalOrderGuideAuthorization.status
    ) {
      if (
        getTranslatedAuthorizationStatus(
          activeSurgicalOrderGuideAuthorization?.status
        )?.title !== 'PENDENTE'
      ) {
        return toast.error('Não é possível editar uma solicitação já enviada.')
      }
    }

    if (!value) {
      cancelAddRow()
      return
    }

    const n = formatedConsultGuideItems.map((item: any) => {
      if (!!item.surgical_order_guide_item_id && item.procedure_id === value) {
        return {
          ...item,
          operation_type: 'DELETE'
        }
      } else if (
        !item.surgical_order_guide_item_id &&
        item.procedure_id === value &&
        !item.surgical_order_guide_item_id
      ) {
        return {
          ...item,
          operation_type: 'EMPTY'
        }
      } else if (
        !item.surgical_order_guide_item_id &&
        item.procedure_id !== value
      ) {
        return {
          ...item
        }
      } else
        return {
          ...item,
          operation_type: null
        }
    })

    const last = n.filter((item: any) => {
      return item.operation_type !== 'EMPTY'
    })

    setFormatedConsultGuideItems(last)
  }

  const guidesCentral = [
    {
      name: 'surgical_order_id',
      label: 'N° Aviso',
      options: { filter: false, sort: false }
    },
    {
      name: 'guide_number',
      label: 'N° Guia',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: 'type',
      label: 'Tipo',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: 'health_insurance_name',
      label: 'Convênio',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: 'accommodation',
      label: 'Acomodação',
      options: {
        filter: true,
        sort: false,
        // eslint-disable-next-line react/display-name
        customBodyRender: () => (
          <AccommodationEdition
            accommodation={accommodation}
            setAccommodation={setAccommodation}
            surgicalOrderGuideAuthorization={
              activeSurgicalOrderGuideAuthorization
            }
          />
        )
      }
    },
    {
      name: 'solicitation_date',
      label: 'Data da solicitação',
      options: {
        filter: true,
        sort: false
        // eslint-disable-next-line react/display-name
      }
    },
    {
      name: 'status',
      label: 'Situação',
      options: {
        filter: true,
        sort: false
        // eslint-disable-next-line react/display-name
      }
    }
  ]

  const guideItems = [
    {
      name: 'procedure_id',
      label: 'Procedimento',
      options: {
        filter: false,
        sort: false,
        // eslint-disable-next-line react/display-name
        customBodyRender: (procedureCode: number) => (
          <ProcedureEdition
            procedureCode={procedureCode}
            searchGuideItem={searchGuideItem}
            cancelAddRow={cancelAddRow}
            error={error}
          />
        )
      }
    },
    {
      name: 'health_insurance_procedure_id',
      label: 'Proc. Convênio',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: 'description',
      label: 'Descrição',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: 'quantity',
      label: 'Solicitado',
      options: {
        filter: true,
        sort: false,
        // eslint-disable-next-line react/display-name
        customBodyRender: (quantityValue: number, rowInfo: any) => (
          <GuideItemQuantityEdition
            surgicalOrderGuideAuthorization={
              activeSurgicalOrderGuideAuthorization
            }
            quantityValue={quantityValue}
            formatedConsultGuideItems={formatedConsultGuideItems}
            setFormatedConsultGuideItems={setFormatedConsultGuideItems}
            selectedProcedureRow={selectedProcedureRow}
            setIsEditingQuantity={setIsEditingQuantity}
            isEditingQuantity={isEditingQuantity}
            rowInfo={rowInfo}
            cancelAddRow={cancelAddRow}
            setSelectedQuantity={setSelectedQuantity}
          />
        )
      }
    },
    {
      name: 'procedure_id',
      label: ' ',
      options: {
        filter: false,
        sort: false,
        // eslint-disable-next-line react/display-name
        customBodyRender: (value: number) => (
          <div onClick={() => removeItem(value)}>
            <TrashIcon />
          </div>
        )
      }
    }
  ]

  useEffect(() => {
    if (surgicalOrderNoticeCard) {
      checkIntegrationOvermind(
        surgicalOrderNoticeCard?.data?.data?.card?.surgical_order_id
      )
    }
  }, [])

  useEffect(() => {
    if (surgicalOrderGuides) {
      loadSurgicalOrderGuideAuthorization()

      const consultGuideItems =
        surgicalOrderGuides?.data?.data?.surgicalOrderGuides[0].items.map(
          (item) => {
            return {
              health_insurance_procedure_id: item.health_insurance_procedure_id,
              procedure_id: item.procedure_id,
              description: item.description,
              quantity: item.quantity,
              operation_type: item.operation_type,
              surgical_order_guide_item_id: item.surgical_order_guide_item_id
            }
          }
        ) as any

      setAccommodation(
        surgicalOrderGuides?.data?.data?.surgicalOrderGuides[0].accommodation
      )
      setFormatedConsultGuideItems(consultGuideItems)
    }
  }, [surgicalOrderGuides])

  const formatedConsultGuide =
    surgicalOrderGuides?.data?.data?.surgicalOrderGuides.map((item) => {
      return {
        ...item,
        guide_number: item.guide_number || item.surgical_order_id,
        health_insurance_name: item.health_insurance.name,
        solicitation_date:
          item.solicitation_date &&
          moment.utc(item.solicitation_date).format('DD/MM/YYYY'),
        status: getTranslatedAuthorizationStatus(item.status).title
      }
    })

  async function loadSurgicalOrderGuides(surgical_order_id: number) {
    try {
      setIsLoading(true)
      const response = await surgicalOrderGuideService.loadSurgicalOrderGuides(
        surgical_order_id
      )
      setSurgicalOrderGuides(response)

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      toast.error('Erro na busca de guias. Tente novamente.')
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  }

  async function checkIntegrationOvermind(surgical_order_id: number) {
    try {
      setIsLoading(true)
      const response = await eligibilityService.checkIntegrationOvermind(
        surgical_order_id
      )
      setIntegrationOvermindInfo(response)

      if (
        !!response?.data.data.integration_overmind[0].is_integrated &&
        surgicalOrderNoticeCard
      ) {
        loadSurgicalOrderGuides(
          surgicalOrderNoticeCard?.data?.data?.card?.surgical_order_id
        )
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      toast.error('Erro na verificação da elegibilidade. Tente novamente.')
    }
  }

  async function loadSurgicalOrderGuideAuthorization() {
    if (surgicalOrderGuides) {
      try {
        setIsLoading(true)

        const response =
          await surgicalOrderGuideService.loadSurgicalOrderGuideAuthorization(
            surgicalOrderGuides.data.data.surgicalOrderGuides[0]
              .surgical_order_guide_id
          )

        setSurgicalOrderGuideAuthorization(response)

        const filtered = response.data.data?.filter((item: any) => {
          return item.is_active === true
        })
        setActiveSurgicalOrderGuideAuthorization(filtered[0])
      } catch (error) {
        toast.error('Erro na busca de guias. Tente novamente.')
      } finally {
        setIsLoading(false)
      }
    }
  }

  async function searchGuideItem(health_insurance_procedure_id: number) {
    setIsLoading(true)
    try {
      const registeredGuideItem = formatedConsultGuideItems.filter(
        (item: any) => {
          return (
            item.health_insurance_procedure_id ===
              health_insurance_procedure_id && item.operation_type !== 'DELETE'
          )
        }
      )

      if (registeredGuideItem.length) {
        return toast.error('Este item já foi adicionado.')
      }

      if (
        surgicalOrderNoticeCard?.data?.data?.card.health_insurance
          .health_insurance_code
      ) {
        const response = await surgicalOrderGuideService.loadGuideItem(
          health_insurance_procedure_id,
          surgicalOrderNoticeCard?.data?.data?.card.health_insurance
            .health_insurance_code
        )

        if (response?.data?.statusCode === 404) {
          setError('Código inválido.')
          return
        }

        if (response.data.data) {
          if (selectedQuantity === 0) {
            return toast.error('Selecione uma quantidade mínima')
          }

          const checkExistingDeletedItem = formatedConsultGuideItems.find(
            (item: any) => {
              return (
                item.health_insurance_procedure_id ===
                  health_insurance_procedure_id &&
                item.operation_type === 'DELETE'
              )
            }
          )

          const formatedFoundGuideItem = {
            ...response.data.data,
            quantity: selectedQuantity,
            operation_type: checkExistingDeletedItem ? 'UPDATE' : 'INSERT',
            surgical_order_guide_item_id: null
          } as any

          const slicedConsultGuideItems = formatedConsultGuideItems.slice(0, -1)

          setFormatedConsultGuideItems([
            ...slicedConsultGuideItems,
            formatedFoundGuideItem
          ])
          setIsAddingRow(false)
        }

        if (response.data.statusCode === 200) {
          toast.success('Item adicionado.')
        }

        if (response.data.statusCode === 500) {
          toast.error('Falha na busca de item da guia.')
        }
        setSelectedQuantity(1)
      }
    } catch (error) {
      toast.error('Falha na busca de item da guia.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleDownload = () => {
    if (surgicalOrderGuides?.data.data.surgicalOrderGuides[0].guide_url) {
      const link = document.createElement('a')
      link.href =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0].guide_url
      link.target = '_blank'
      link.target = '_blank'
      link.download
      link.click()
    }
  }

  async function createAuthorizationSolicitation() {
    try {
      setIsLoading(true)

      if (!formatedConsultGuideItems.length) {
        return toast.error('Adicione pelo menos um item na guia')
      }

      let hasItemWithoutQuantity = 0
      formatedConsultGuideItems.forEach((item: any) => {
        if (item.quantity === 0 && item.operation_type !== 'DELETE') {
          hasItemWithoutQuantity += 1
        }
      })

      if (hasItemWithoutQuantity > 0) {
        return toast.error('Defina uma quantidade para os itens adicionados')
      }

      const surgical_order_guide_id =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0]
          .surgical_order_guide_id
      const surgical_order_id =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0].surgical_order_id
      const health_insurance_id =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0].health_insurance
          .health_insurance_id
      const health_insurance_name =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0].health_insurance
          .name
      const type = surgicalOrderGuides?.data.data.surgicalOrderGuides[0].type
      const status =
        surgicalOrderGuides?.data.data.surgicalOrderGuides[0].status

      if (
        !!surgical_order_guide_id &&
        surgical_order_id &&
        health_insurance_id &&
        health_insurance_name &&
        type &&
        status
      ) {
        const authorizationRequestObject = {
          surgical_order_guide: {
            surgical_order_guide_id: surgical_order_guide_id,
            surgical_order_id: surgical_order_id,
            accommodation: accommodation,
            health_insurance: {
              health_insurance_id: health_insurance_id,
              name: health_insurance_name
            },
            solicitation_date:
              surgicalOrderGuides?.data.data.surgicalOrderGuides[0]
                .solicitation_date,
            type: type,
            status: status,
            items: formatedConsultGuideItems
          }
        }

        await surgicalOrderGuideService.createSurgicalOrderGuideConsultAuthorization(
          authorizationRequestObject
        )

        toast.success('Solicitação de autorização enviada')

        loadSurgicalOrderGuideAuthorization()

        if (surgicalOrderNoticeCard) {
          checkIntegrationOvermind(
            surgicalOrderNoticeCard?.data?.data?.card?.surgical_order_id
          )
        }
      }
    } catch (error) {
      toast.error('Ocorreu um erro ao solicitar autorização')
    } finally {
      setIsLoading(false)
    }
  }

  {
    if (integrationOvermindInfo?.data.data.name === 'PARTICULAR') {
      return (
        <>
          <S.CenterContainer style={{ marginRight: '330px' }}>
            <S.TextStrong>
              Pedido particular. Não é possível realizar solicitação de
              autorização automatizada pelo Meu Mater Dei.
            </S.TextStrong>
          </S.CenterContainer>
        </>
      )
    } else if (
      integrationOvermindInfo?.data.data.integration_overmind[0]
        ?.is_integrated === false
    ) {
      return (
        <>
          <S.CenterContainer style={{ marginRight: '330px' }}>
            <S.TextStrong>
              O convênio informado ainda não possui verificação de autorização
              automatizada. Consulte o canal oficial do convênio e realize as
              alterações necessárias no MV.
            </S.TextStrong>
          </S.CenterContainer>
        </>
      )
    } else if (
      (activeSurgicalOrderGuideAuthorization && integrationOvermindInfo) ||
      !!surgicalOrderGuides?.data?.data.surgicalOrderGuides
    ) {
      return (
        <>
          <S.CenterContainer>
            <S.StrongTitle>Central de Guias</S.StrongTitle>

            <Table
              columns={guidesCentral}
              data={formatedConsultGuide}
              pagination={false}
            />

            <S.StrongTitle style={{ marginTop: '20px' }}>
              Itens das Guias
            </S.StrongTitle>

            <Table
              columns={guideItems}
              data={
                !!formatedConsultGuideItems?.length &&
                (formatedConsultGuideItems.filter((item: any) => {
                  return item.operation_type !== 'DELETE'
                }) as any)
              }
              pagination={false}
              onClick={onRowClick}
            />

            <S.ButtonPanel>
              {!isAddingRow && !isEditingQuantity ? (
                <>
                  <ButtonNew
                    onClick={() => addRow()}
                    icon={<PlusIcon width={12} />}
                    outlined
                    disabled={
                      activeSurgicalOrderGuideAuthorization?.status &&
                      getTranslatedAuthorizationStatus(
                        activeSurgicalOrderGuideAuthorization?.status
                      )?.title !== 'PENDENTE'
                    }
                  >
                    Adicionar Item
                  </ButtonNew>
                </>
              ) : (
                <>
                  <ButtonNew onClick={() => cancelAddRow()} outlined>
                    Cancelar
                  </ButtonNew>
                </>
              )}

              <ButtonNew
                onClick={createAuthorizationSolicitation}
                disabled={
                  activeSurgicalOrderGuideAuthorization?.status &&
                  getTranslatedAuthorizationStatus(
                    activeSurgicalOrderGuideAuthorization?.status
                  )?.title !== 'PENDENTE' &&
                  getTranslatedAuthorizationStatus(
                    activeSurgicalOrderGuideAuthorization?.status
                  )?.title !== 'Falha de autorização'
                }
              >
                Solicitar autorização
              </ButtonNew>
            </S.ButtonPanel>
          </S.CenterContainer>

          {activeSurgicalOrderGuideAuthorization?.status &&
            getTranslatedAuthorizationStatus(
              activeSurgicalOrderGuideAuthorization?.status
            )?.title !== 'PENDENTE' && (
              <>
                <S.Separator />
                <S.RightContainer>
                  <S.StrongTitle>
                    Status da solicitação de autorização
                  </S.StrongTitle>

                  <S.StrongLabel>Autorização do convênio</S.StrongLabel>

                  {surgicalOrderGuideAuthorization && (
                    <S.AuthorizationStatusContainer>
                      <TimelineAuthorizationStatus
                        surgicalOrderGuideAuthorization={
                          surgicalOrderGuideAuthorization
                        }
                      />
                    </S.AuthorizationStatusContainer>
                  )}
                  <S.StrongLabel>Envio da solicitação</S.StrongLabel>

                  {activeSurgicalOrderGuideAuthorization.user?.name && (
                    <S.AuthorizationStatusBlock>
                      <label>
                        {moment(
                          // activeSurgicalOrderGuideAuthorization?.created_at
                          surgicalOrderGuides?.data?.data
                            ?.surgicalOrderGuides[0]?.solicitation_date
                        )
                          .utc()
                          .format('DD/MM/YYYY - HH[h]mm')}
                      </label>
                      <div>
                        <span>
                          Por{' '}
                          {`${activeSurgicalOrderGuideAuthorization?.user?.name}`}
                        </span>
                        {!!activeSurgicalOrderGuideAuthorization?.user
                          ?.last_name && (
                          <>
                            {' '}
                            <span>
                              {
                                activeSurgicalOrderGuideAuthorization?.user
                                  ?.last_name
                              }{' '}
                            </span>
                          </>
                        )}
                      </div>
                    </S.AuthorizationStatusBlock>
                  )}

                  {activeSurgicalOrderGuideAuthorization.updated_at && (
                    <>
                      <S.StrongLabel>Última atualização</S.StrongLabel>
                      <S.AuthorizationStatusContainer>
                        <span>
                          {moment(
                            activeSurgicalOrderGuideAuthorization?.updated_at
                          )
                            .utc()
                            .format('DD/MM/YYYY - HH[h]mm')}
                        </span>
                      </S.AuthorizationStatusContainer>
                    </>
                  )}

                  {activeSurgicalOrderGuideAuthorization?.protocol && (
                    <>
                      <S.StrongLabel>Protocolo</S.StrongLabel>
                      <S.AuthorizationStatusBlock>
                        <span>
                          {activeSurgicalOrderGuideAuthorization?.protocol}
                        </span>
                      </S.AuthorizationStatusBlock>
                    </>
                  )}

                  {(getTranslatedAuthorizationStatus(
                    activeSurgicalOrderGuideAuthorization.status
                  )?.title !== 'Solicitado' &&
                    getTranslatedAuthorizationStatus(
                      activeSurgicalOrderGuideAuthorization.status
                    )?.title !== 'Em análise') ||
                    (getTranslatedAuthorizationStatus(
                      activeSurgicalOrderGuideAuthorization.status
                    )?.title !== 'Falha de autorização' && (
                      <>
                        <S.AuthorizationStatusBlock>
                          {!!activeSurgicalOrderGuideAuthorization?.password && (
                            <>
                              <S.StrongLabel>Senha</S.StrongLabel>
                              <span>
                                {
                                  activeSurgicalOrderGuideAuthorization?.password
                                }
                              </span>
                            </>
                          )}

                          {!!activeSurgicalOrderGuideAuthorization?.validate_password && (
                            <span>
                              Válida até{' '}
                              {moment
                                .utc(
                                  activeSurgicalOrderGuideAuthorization?.validate_password
                                )
                                .format('DD/MM/yyyy')}
                            </span>
                          )}
                        </S.AuthorizationStatusBlock>
                      </>
                    ))}
                  <>
                    {surgicalOrderGuides?.data.data.surgicalOrderGuides[0]
                      .guide_url && (
                      <ButtonNew onClick={handleDownload} outlined>
                        <S.StyledIcon>
                          <DownloadIcon width={20} />
                        </S.StyledIcon>
                        Baixar guia
                      </ButtonNew>
                    )}
                  </>
                </S.RightContainer>
              </>
            )}
        </>
      )
    } else if (
      surgicalOrderGuides?.data?.data.surgicalOrderGuides.length === 0
    ) {
      return (
        <>
          <S.CenterContainer style={{ marginRight: '330px' }}>
            <S.TextStrong>
              Não foi encontrada nenhuma guia de autorização.
            </S.TextStrong>
          </S.CenterContainer>
        </>
      )
    } else
      return (
        <>
          <LoadingModal show={true} />
        </>
      )
  }
}

const ClickContainer = (props: any) => {
  const [clickCount, setClickCount] = useState(0)

  const handleClick = () => {
    setClickCount((prevCount) => prevCount + 1)
  }

  useEffect(() => {
    let timeout: NodeJS.Timeout

    if (clickCount === 1) {
      // Handle single click

      if (
        getTranslatedAuthorizationStatus(
          props.surgicalOrderGuideAuthorization?.data?.data?.status
        )?.title === 'PENDENTE'
      ) {
        props.setIsEditingQuantity(true)
      } else {
        props.setIsEditingQuantity(false)
      }
      timeout = setTimeout(() => {
        setClickCount(0)
      }, 300)
    } else if (clickCount === 2) {
      // Handle double click
      // props.setIsEditingQuantity(true)
      setClickCount(0)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [clickCount])

  return <div onClick={handleClick}>{props.children}</div>
}

const AccommodationEdition = ({
  surgicalOrderGuideAuthorization,
  accommodation,
  setAccommodation
}: any) => {
  const wrapperRef = useRef(null) as any

  const [editAccommodation, setEditAccommodation] = useState(false)

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setEditAccommodation(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  function handleSelectAccommodation(value: string) {
    const guide_accommodation_type_id = value.split(' -')[0]
    const description = value.split('- ')[1].trimEnd()

    setAccommodation({
      guide_accommodation_type_id: +guide_accommodation_type_id,
      description: description
    })
    setEditAccommodation(false)
  }

  function handleOpenEditAccomodation() {
    if (
      getTranslatedAuthorizationStatus(
        surgicalOrderGuideAuthorization?.data?.data?.status
      )?.title !== 'PENDENTE'
    ) {
      setEditAccommodation(false)
    } else setEditAccommodation(true)
  }

  return (
    <>
      {!editAccommodation ? (
        <S.AccommodationSwitch onClick={() => handleOpenEditAccomodation()}>
          <span>
            {!!accommodation &&
              `${accommodation.guide_accommodation_type_id} - ${accommodation.description}`}
          </span>
          <div>
            <PencilIcon />
          </div>
        </S.AccommodationSwitch>
      ) : (
        <div
          ref={wrapperRef}
          style={{
            width: '200px',
            display: 'flex',
            margin: 'auto',
            placeContent: 'center'
          }}
        >
          <SelectField
            items={accommodations.map((accommodation: any) => ({
              label: `${accommodation.guide_accommodation_type_id} - ${accommodation.description} `,
              value: `${accommodation.guide_accommodation_type_id} - ${accommodation.description} `
            }))}
            onChange={(evt: any) => handleSelectAccommodation(evt.target.value)}
          />
        </div>
      )}
    </>
  )
}

const GuideItemQuantityEdition = ({
  surgicalOrderGuideAuthorization,
  quantityValue,
  formatedConsultGuideItems,
  setFormatedConsultGuideItems,
  selectedProcedureRow,
  setIsEditingQuantity,
  isEditingQuantity,
  rowInfo,
  cancelAddRow,
  setSelectedQuantity
}: any) => {
  const handleKeyDownQuantity = (event: any) => {
    if (event.key === 'Enter') {
      if (surgicalOrderGuideAuthorization) {
        if (
          getTranslatedAuthorizationStatus(
            surgicalOrderGuideAuthorization?.data?.data?.status
          )?.title !== 'PENDENTE'
        ) {
          return toast.error(
            'Não é possível editar uma solicitação já enviada.'
          )
        }
      }

      const quantity = event.target.value
      if (+quantity === 0) {
        return toast.error('Selecione uma quantidade mínima')
      }
      setSelectedQuantity(quantity)

      const consultGuideItems = formatedConsultGuideItems.map((item: any) => {
        if (item.procedure_id === selectedProcedureRow) {
          return {
            health_insurance_procedure_id: item.health_insurance_procedure_id,
            procedure_id: item.procedure_id,
            description: item.description,
            quantity: +quantity,
            operation_type: item.operation_type,
            surgical_order_guide_item_id: item.surgical_order_guide_item_id
          }
        } else return item
      }) as any
      setFormatedConsultGuideItems(consultGuideItems)
      setIsEditingQuantity(false)
    }

    if (event.keyCode === 27) {
      cancelAddRow()
    }
  }

  return (
    <>
      {isEditingQuantity && rowInfo.rowData[0] !== selectedProcedureRow ? (
        <>
          <div>
            <span style={{ marginRight: '9px' }}>{quantityValue}</span>
            <PencilIcon />
          </div>
        </>
      ) : !isEditingQuantity && rowInfo.rowData[0] !== selectedProcedureRow ? (
        <>
          <ClickContainer
            surgicalOrderGuideAuthorization={surgicalOrderGuideAuthorization}
            setIsEditingQuantity={setIsEditingQuantity}
          >
            <div>
              <span style={{ marginRight: '9px' }}>{quantityValue}</span>
              <PencilIcon />
            </div>
          </ClickContainer>
        </>
      ) : isEditingQuantity && rowInfo.rowData[0] === selectedProcedureRow ? (
        <>
          <div
            style={{
              width: '110px',
              display: 'flex',
              placeContent: 'center',
              margin: 'auto'
            }}
          >
            <TextFieldNew
              onKeyDown={(evt: any) => handleKeyDownQuantity(evt)}
              placeholder="Quantidade"
              autoFocus
            />
          </div>
        </>
      ) : (
        <>
          <ClickContainer
            surgicalOrderGuideAuthorization={surgicalOrderGuideAuthorization}
            setIsEditingQuantity={setIsEditingQuantity}
          >
            <div>
              <span style={{ marginRight: '9px' }}>{quantityValue}</span>
              <PencilIcon />
            </div>
          </ClickContainer>
        </>
      )}
    </>
  )
}

const ProcedureEdition = ({
  procedureCode,
  searchGuideItem,
  cancelAddRow,
  error
}: any) => {
  const handleKeyDownProcedure = (event: any) => {
    if (event.key === 'Enter') {
      searchGuideItem(event.target.value)
    }

    if (event.keyCode === 27) {
      cancelAddRow()
    }
  }

  return (
    <>
      {procedureCode ? (
        <>
          <span>{procedureCode}</span>
        </>
      ) : (
        <div
          style={{
            width: '140px',
            display: 'flex',
            placeContent: 'center',
            margin: 'auto'
          }}
        >
          <TextFieldNew
            onKeyDown={handleKeyDownProcedure}
            placeholder="N° Procedimento"
            error={error}
            autoFocus
          />
        </div>
      )}
    </>
  )
}

const TimelineAuthorizationStatus = ({
  surgicalOrderGuideAuthorization
}: SurgicalOrderGuideAuthorizationProps) => {
  const statusList = surgicalOrderGuideAuthorization.data.data
    .map((item: SurgicalOrderGuideAuthorization) => {
      if (item) {
        return {
          date: `${moment
            .utc(item.created_at)
            .locale('pt-br')
            .format('DD [de] MMMM')} às ${moment
            .utc(item.created_at)
            .locale('pt-br')
            .format('LT')}`,

          status:
            item.status && getTranslatedAuthorizationStatus(item.status).title,
          color:
            item.status && getTranslatedAuthorizationStatus(item.status).color,
          reason: item?.reason
        }
      }
    })
    .reverse()

  return (
    <>
      {surgicalOrderGuideAuthorization &&
        surgicalOrderGuideAuthorization?.data?.data.length > 1 && (
          <>
            <S.ContainerTimeline>
              {statusList.map((item: any, index: number) => {
                return (
                  <S.ItemList colorBall={item.color} key={index}>
                    <strong>{item.status}</strong>
                    <span>{item.date}</span>
                    <strong>{item?.reason && 'Motivo do Erro'}</strong>
                    <span>{item?.reason}</span>
                  </S.ItemList>
                )
              })}
            </S.ContainerTimeline>
          </>
        )}

      {surgicalOrderGuideAuthorization &&
        surgicalOrderGuideAuthorization?.data?.data.length === 1 && (
          <>
            <S.SingleStatusContainer>
              <S.Ball
                colorBall={
                  surgicalOrderGuideAuthorization?.data?.data?.[0]?.status &&
                  getTranslatedAuthorizationStatus(
                    surgicalOrderGuideAuthorization?.data?.data?.[0]?.status
                  )?.color
                }
              />
              <span>
                {surgicalOrderGuideAuthorization?.data?.data?.[0]?.status &&
                  getTranslatedAuthorizationStatus(
                    surgicalOrderGuideAuthorization?.data?.data?.[0]?.status
                  )?.title}
              </span>
            </S.SingleStatusContainer>
          </>
        )}
    </>
  )
}
